'use client';

import { alpha, Box, IconButton } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { signIn, useSession } from "next-auth/react";
import clsx from "clsx";

export default function SignInButton() {

    const session = useSession();

    return (
        <Box
            className={clsx(
                "items-center justify-center w-16 h-16 absolute bottom-2 right-2 z-[1000] rounded-[50%]",
                session.status == "authenticated" ? "hidden" : "hidden md:flex"
            )}
        >
            <IconButton
                aria-hidden
                tabIndex={-1}
                onClick={() => signIn()}
            >
                <Lock
                    sx={{
                        color: (theme) => alpha(theme.palette.primary.main, 0.8)
                    }}
                />
            </IconButton>
        </Box>
    )
}
